<template>
    <Modal :title="props.title">
        <template v-slot:body>
            {{ props.text }}
        </template>
        <template v-slot:footer>
            <input type="button" :value="confirmBtnText" class="button" @click="close()" />
        </template>
    </Modal>
</template>

<script setup>
    import { defineProps, defineEmits } from 'vue';
    import { Modal as ModalLib } from 'jenesius-vue-modal';
    import Modal from './Modal.vue';

    const props = defineProps({
        title: {
            type: String,
            default: ''
        },

        text: {
            type: String,
            reqiured: true
        },

        confirmBtnText: {
            type: String,
            default: 'Close'
        },

        dangerous: {
            type: Boolean,
            default: false
        }
    });

    const emit = defineEmits([ModalLib.EVENT_PROMPT]);

    async function close() {
        emit(ModalLib.EVENT_PROMPT, true);
    }
</script>
